import { BehaviorSubject } from "rxjs";
export interface ToastMessage {
  text: string;
  type: "success" | "danger";
}

export class NotificationService {
  timeOutId: number | null = null;
  private remainingTime = 4000;
  private startTime = 0;
  private toastSubject = new BehaviorSubject<ToastMessage | null>(null);
  toast$ = this.toastSubject.asObservable();

  success(text: string) {
    this.show({ text, type: "success" });
  }

  error(text: string) {
    this.show({ text, type: "danger" });
  }

  close() {
    if (this.timeOutId != null) {
      clearTimeout(this.timeOutId);
      this.timeOutId = null;
    }
    this.toastSubject.next(null);
  }

  pause() {
    if (this.timeOutId !== null) {
      clearTimeout(this.timeOutId);
      this.timeOutId = null;
      this.remainingTime -= Date.now() - this.startTime;
    }
  }

  resume() {
    if (this.timeOutId === null && this.remainingTime > 0) {
      this.startTimer();
    }
  }

  private show(toast: ToastMessage) {
    this.clearTimer();
    this.remainingTime = 4000;

    // reset toast
    this.toastSubject.next(null);

    setTimeout(() => {
      this.toastSubject.next(toast);
      this.startTimer();
    }, 0);
  }

  private startTimer() {
    this.startTime = Date.now();
    this.timeOutId = window.setTimeout(() => {
      this.toastSubject.next(null);
      this.timeOutId = null;
    }, this.remainingTime);
  }

  private clearTimer() {
    if (this.timeOutId !== null) {
      clearTimeout(this.timeOutId);
      this.timeOutId = null;
    }
  }
}
